import { render } from "./QueuedActivitiesDashboard.vue?vue&type=template&id=28c219ad&scoped=true"
import script from "./QueuedActivitiesDashboard.vue?vue&type=script&lang=js"
export * from "./QueuedActivitiesDashboard.vue?vue&type=script&lang=js"

import "./QueuedActivitiesDashboard.vue?vue&type=style&index=0&id=28c219ad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c219ad"]])

export default __exports__